// Import the modular BagScene from the bagmenu folder
import ActionMenuHandler from './bagmenu/handlers/ActionMenuHandler'; // <-- Correct Import Path
import Phaser from 'phaser';
import BagScene from './bagmenu';

// Export the BagScene class
export default BagScene;
